
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facilities/[...slug]",
      function () {
        return require("private-next-pages/facilities/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facilities/[...slug]"])
      });
    }
  